/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export enum CreateOfferStep {
    Details = 1,
    PackageItems = 2,
    Upsells = 3,
    Overview = 4,
    Finish = 5,
}
